import { render, staticRenderFns } from "./MhPdfViewer.vue?vue&type=template&id=5796baa4&scoped=true"
import script from "./MhPdfViewer.vue?vue&type=script&lang=js"
export * from "./MhPdfViewer.vue?vue&type=script&lang=js"
import style0 from "./MhPdfViewer.vue?vue&type=style&index=0&id=5796baa4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5796baa4",
  null
  
)

export default component.exports